<div class="user-result" (click)="onUserClick()">
  <div class="result-icon user-icon" *ngIf="showIcon">
    <ddc-profile-pic-only [userProfilePic]="result.info?.profile_pic || _DefaultProfilePic"> </ddc-profile-pic-only>
  </div>
  <div class="result-content">
    <div class="result-header">
      <div class="user-info-line">
        <ddc-profile-pic-only *ngIf="!showIcon" [userProfilePic]="result.info?.profile_pic || _DefaultProfilePic">
        </ddc-profile-pic-only>
        <span class="username" [innerHTML]="result.label"></span>
        <mat-icon class="small-icon ddc-plus-icon" *ngIf="result.info?.subscription === 'Plus'" matTooltip="Plus"
          >bolt</mat-icon
        >
      </div>
      <span class="separator" *ngIf="result.info?.language_1"> • </span>
      <div class="user-languages" *ngIf="result.info?.language_1">
        <ddc-country-flag [ddc_lng]="result.info?.language_1" [has_label]="false"></ddc-country-flag>
        <ddc-country-flag
          *ngIf="result.info?.language_2"
          [ddc_lng]="result.info?.language_2"
          [has_label]="false"
        ></ddc-country-flag>
        <ddc-country-flag
          *ngIf="result.info?.language_3"
          [ddc_lng]="result.info?.language_3"
          [has_label]="false"
        ></ddc-country-flag>
      </div>
    </div>
  </div>
</div>
